<template>
  <div v-loading="loading">
    <div class="detail_echart_top">
      <div class="detail_top_item">
        <div class="detail_top_item_title">
          <OverflowTooltip
            :tip="shareholderChartSummaryObject?.ultimateBeneficiary"
            :lineClamp="2"
          />
        </div>
        <div class="detail_top_item_value">
          {{ $t("Relationship.UItimateBeneficiaryOwner") }}
        </div>
      </div>
      <div class="detail_top_item">
        <div class="detail_top_item_title">
          {{ shareholderChartSummaryObject?.shareholdingLayers | FormatNum }}
        </div>
        <div class="detail_top_item_value">
          {{ $t("Relationship.ShareholderLevel") }}
        </div>
      </div>
      <div class="detail_top_item">
        <div class="detail_top_item_title">
          {{ shareholderChartSummaryObject?.partiesInvolved | FormatNum }}
        </div>
        <div class="detail_top_item_value">
          {{ $t("Relationship.PartiesInvolved") }}
        </div>
      </div>
      <div class="detail_top_item">
        <div class="detail_top_item_title">
          {{ shareholderChartSummaryObject?.relatedCompany | FormatNum }}
        </div>
        <div class="detail_top_item_value">
          {{ $t("Relationship.RelatedCompanies") }}
        </div>
      </div>
      <div class="detail_top_item">
        <div class="detail_top_item_title">
          {{ shareholderChartSummaryObject?.companyShareholders | FormatNum }}
        </div>
        <div class="detail_top_item_value">
          {{ $t("Relationship.CoShareholders") }}
        </div>
      </div>
      <div class="detail_top_item">
        <div class="detail_top_item_title">
          {{ shareholderChartSummaryObject?.ngoShareholders | FormatNum }}
        </div>
        <div class="detail_top_item_value">
          {{ $t("Relationship.NGOShareholders") }}
        </div>
      </div>
      <div class="detail_top_item">
        <div class="detail_top_item_title">
          {{
            shareholderChartSummaryObject?.naturalPersonShareholder | FormatNum
          }}
        </div>
        <div class="detail_top_item_value">
          {{ $t("Relationship.NaturalPersonShareholders") }}
        </div>
      </div>
      <div class="detail_top_item">
        <div class="detail_top_item_title">
          {{ shareholderChartSummaryObject?.subjectInvestments | FormatNum }}
        </div>
        <div class="detail_top_item_value">
          {{ $t("Relationship.SubjectsInvestments") }}
        </div>
      </div>
    </div>
    <div class="detail_echart_table">
      <div class="operations-head operations-head-content">
        {{ $t("Relationship.CompanyShareholders") }}
        <div class="ruler_table_right">
          <div class="ruler_item">
            <div class="ruler_item_label">
              {{ $t("Relationship.Numberofshareholderenterprises") }}:
            </div>
            <div class="ruler_item_content">
              {{ tableData.length ? tableData.length : 0 }}
            </div>
          </div>
          <div class="ruler_slider">
            <DiscreteSlider v-model="percent" @changeRuler="onChangeRuler" />
          </div>
        </div>
      </div>
      <el-table
        class="risk_table"
        :data="tableData"
        height="100%"
        ref="tableRef"
        row-key="aaaId"
      >
        <el-table-column
          prop="companyName"
          :label="$t('Relationship.CompanyName')"
          min-width="200"
          show-overflow-tooltip
        >
          <template v-slot:header>
            <div
              class="table_header_search_title"
              @click="isSearchName = false"
              v-if="isSearchName"
            >
              {{ $t("Relationship.CompanyName") }}
              <i class="iconfont icon-jiantouxia" />
            </div>
            <el-select
              v-else
              style="width: 100%"
              clearable
              filterable
              class="table_header_search"
              popper-class="new-search-select auto"
              :placeholder="$t('Relationship.Entercompanyname')"
              v-model="filterName"
              @change="(val) => filterSearch(val, 'company')"
            >
              <el-option
                v-for="(value, index) in companyOptions"
                :key="index"
                :value="value"
                :label="value"
              />
            </el-select>
          </template>
          <template #default="{ row }">
            <!-- <span class="link_hover_text" @click="goDetail(row)">
              {{ row.companyName }}
            </span> -->
            <span
              class="link_hover_text"
              v-if="row.type == 'Company'"
              @click="goDetail(row)"
            >
              {{ row.companyName }}</span
            >
            <span v-else>
              {{ row.companyName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="currentLevel"
          align="center"
          :label="$t('Relationship.CurrentLevel')"
          min-width="100"
        >
          <template v-slot:header>
            <div
              class="table_header_search_title"
              @click="isSearchLevel = false"
              v-if="isSearchLevel"
            >
              {{ $t("Relationship.CurrentLevel") }}
              <i class="iconfont icon-jiantouxia" />
            </div>
            <el-select
              v-else
              style="width: 100%"
              clearable
              filterable
              class="table_header_search"
              popper-class="new-search-select auto"
              :placeholder="$t('Relationship.EnterCurrentLevel')"
              v-model="filterLevel"
              @change="(val) => filterSearch(val, 'level')"
            >
              <el-option
                v-for="(value, key, index) in levelObjs"
                :key="index"
                :value="key"
                :label="key"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="holdingRatioDesc"
          :label="$t('Relationship.SharesonSubjectCo')"
          align="center"
          min-width="145"
        >
        </el-table-column>
        <el-table-column
          prop="country"
          align="center"
          :label="$t('Relationship.Country')"
          min-width="120"
        >
          <template v-slot:header>
            <div
              class="table_header_search_title"
              @click="isSearchCountry = false"
              v-if="isSearchCountry"
            >
              {{ $t("Relationship.Country") }}
              <i class="iconfont icon-jiantouxia" />
            </div>
            <el-select
              v-else
              style="width: 100%"
              clearable
              filterable
              class="table_header_search"
              popper-class="new-search-select auto"
              :placeholder="$t('Relationship.EnterCountry')"
              v-model="filterName"
              @change="(val) => filterSearch(val, 'country')"
            >
              <el-option
                v-for="(value, index) in countryOptions"
                :key="index"
                :value="value"
                :label="value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          align="center"
          :label="$t('Relationship.Type')"
          min-width="100"
        >
        </el-table-column>
      </el-table>
    </div>

    <Tips :dialogVisible.sync="isShowTips"></Tips>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import Page from "@/views/newLayout/page.vue";
import Tips from "@/views/newLayout/tips.vue";
import DiscreteSlider from "./Com_DiscreteSlider.vue";
import { getShareholderDeepList } from "@/api/uboApi";
import { getShareholderChartSummary } from "@/api/companyApi";
export default {
  name: "UboDetail7",
  mixins: [mixins1],
  components: {
    Page,
    Tips,
    DiscreteSlider,
  },
  data() {
    return {
      percent: 50, //刻度百分比
      loading: false,
      isShowTips: false,
      filterLevel: "",
      total: 0,
      params: {
        aaaid: this.$route.query.id3a,
        holdingRatio: "",
        currentLevel: "",
      },
      shareholderChartSummaryObject: {},
      levelObjs: {},
      largeCompany: "",
      tableData: [],
      localTableData: [],
      isSearchName: true,
      isSearchLevel: true,
      isSearchCountry: true,
      filterName: "",
      filterLevel: "",
      filterCountry: "",
      companyOptions: [],
      countryOptions: [],
    };
  },
  methods: {
    onChangePage(param) {},
    // 跳转ubo详细
    goDetail(row) {
      let routeData = this.$router.resolve({
        path: "/ubo/detail",
        query: {
          id3a: row.aaaid,
          keyword: row.companyName,
          selectKey: "Company",
        },
      });
      window.open(routeData.href, "_blank");
    },
    // 滑动标尺
    onChangeRuler(val) {
      // this.filterLevel = "";
      this.isSearchName=true
      this.isSearchLevel=true
      this.isSearchCountry=true
      this.filterName= ""
      this.filterLevel= ""
      this.filterCountry=""
      if (val == 0) {
        this.tableData = [];
      }
      this.params.holdingRatio = val;
      this.getShareholderDeepListApi();
    },
    // 选择level
    filterSearch(val, type) {
      // this.params.currentLevel = val;
      // this.getShareholderDeepListApi();
      if (val) {
        if (type == "company") {
          this.tableData = this.localTableData.filter(
            (list) => list.companyName == val,
          );
        }
        if (type == "level") {
          this.tableData = this.localTableData.filter(
            (list) => list.currentLevel == val,
          );
        }
        if (type == "country") {
          this.tableData = this.localTableData.filter(
            (list) => list.country == val,
          );
        }
      } else {
        this.tableData = this.localTableData;
      }
    },
    // 初始化
    async getShareholderDeepListApi() {
      this.loading = true;
      this.tableData = [];
      this.levelObjs = {};
      this.largeCompany = "";
      let res = await getShareholderDeepList(this.params);
      if (res) {
        this.levelObjs = res.data.map;
        this.largeCompany = res.data.largestHoldingCompany;
        this.largeCompanyid = res.data.aaaid;
        // if (this.filterLevel != "") {
        this.tableData = Object.freeze(res.data.shareholderDeepVOList);
        this.localTableData = Object.freeze(res.data.shareholderDeepVOList);
        this.companyOptions = Object.freeze(
          [
            ...new Set(
              res.data.shareholderDeepVOList.map((item) => item.companyName),
            ),
          ].filter(Boolean),
        );
        this.countryOptions = Object.freeze(
          [
            ...new Set(
              res.data.shareholderDeepVOList.map((item) => item.country),
            ),
          ].filter(Boolean),
        );
        // }

        this.loading = false;
      }
    },
    getShareholderChartSummaryList() {
      getShareholderChartSummary({
        id3a: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.shareholderChartSummaryObject = res.data;
        }
      });
    },
  },
  mounted() {
    this.getShareholderChartSummaryList();
    // this.getShareholderDeepListApi();
  },
};
</script>
<style scoped>
.operations-head {
  color: #603c2c;
}
.detail_content_tab_con_echart {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.detail_echart_table {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.ruler_table_right {
  display: flex;
  gap: 40px;
  align-self: baseline;
}

.ruler_slider {
  width: 470px;
  flex-shrink: 0;
  height: auto;
}
.ruler_item + .ruler_item {
  margin-top: 10px;
}
.ruler_item {
  width: 100%;
  height: 44px;
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 10px;
}
.ruler_item.lines_item {
  height: auto;
  flex-direction: column;
  align-items: flex-start;
}
.ruler_item_label {
  flex-shrink: 0;
  font-size: 18px;
  color: #1a2332;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  font-family: "Arial Bold";
}
.ruler_item_content {
  flex: 1;
  font-size: 18px;
  color: #1a2332;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  overflow: hidden;
  font-family: "Arial Bold";
  color: #3fb92f;
}
.link_text {
  color: #b44818;
  cursor: pointer;
}
.ruler_item_content >>> .el-input__inner {
  height: 32px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #cccccc;
  box-sizing: border-box;
}
.risk_table {
  min-height: 360px;
  flex: 1;
  height: auto !important;
  overflow: hidden;
}
.risk_table >>> .el-table__empty-block {
  margin-top: 40px;
  background: url("../../assets/images/ruler_empty_bg.png") no-repeat;
  background-size: auto 82%;
  background-position: center center;
}
.risk_table >>> .el-table__empty-block .el-table__empty-text {
  opacity: 0;
}
.table_header_search_title {
  cursor: pointer;
  padding-left: 9px;
  padding-right: 9px;
  font-family: "Arial Bold";
  font-size: 18px !important;
  color: #1a2332;
  line-height: 24px;
  font-style: normal;
}
.table_header_search_title i {
  color: #b44818;
}

@media (max-width: 1920px) {
  .ruler_table_right {
    gap: 30px;
  }

  .ruler_slider {
    width: 350px;
    height: auto;
  }
  .ruler_item {
    height: 34px;
  }
  .ruler_item + .ruler_item {
    margin-top: 8px;
  }
  .ruler_item {
    height: 34px;
    gap: 8px;
    padding: 6px 8px;
  }
  .ruler_item_label {
    font-size: 16px;
    line-height: 20px;
  }
  .ruler_item_content {
    font-size: 16px;
    line-height: 20px;
  }
  .ruler_item_content >>> .el-input__inner {
    height: 28px;
  }
  .risk_table {
    min-height: 300px;
  }
  .risk_table >>> .el-table__empty-block {
    margin-top: 20px;
    background-size: auto 82%;
    background-position: center center;
  }
  .table_header_search_title {
    padding-left: 7px;
    padding-right: 7px;
    font-size: 16px !important;
    line-height: 20px;
  }
  .table_header_search ::v-deep .el-input--suffix {
    height: 36px;
  }
}
</style>
